import React from "react";
import { Tabs, Tab, Image } from "react-bootstrap";

const GroupPackageTabs = () => {
  const packages = [
    { key: "min", title: "Minimum 40 Pax group", price: "₹ 975" },
    { key: "min2", title: "Minimum 75 Pax group", price: "₹ 950" },
    { key: "min3", title: "Minimum 100 Pax group", price: "₹ 925" },
    { key: "min4", title: "Minimum 125 Pax group", price: "₹ 900" },
    { key: "min5", title: "Minimum 150 Pax group", price: "₹ 875" },
    { key: "min6", title: "Minimum 200 Members & Above", price: "₹ 825" },
  ];

  const includes = [
    {
      icon: "ic-rural-activities.png",
      label: "All the Programme, Cultural, Live Traditional Dances",
    },
    {
      icon: "ic-ltd-food.png",
      label:
        "Limited Food, Special Thali, Animal Welcoming Travel, and Unlimited A/C Sit down Dinner",
    },
    {
      icon: "ic-restaurant-entry.png",
      label:
        "A/C Party Hall Rent Free for 60 minutes ElectricityChargesextra onlyforA/C Hall.",
    },
  ];

  return (
    <div className="tab-blk">
      <Tabs defaultActiveKey="min" id="group-packages" className="mb-3">
        {packages.map((pkg) => (
          <Tab eventKey={pkg.key} title={pkg.title} key={pkg.key}>
            <div className="row">
              <div className="col-md-4">
                <div className="item-bx last">
                  <figure>
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/adult.png`}
                      fluid
                    />
                  </figure>
                  <div className="logo">
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/head-img.png`}
                      fluid
                    />
                  </div>
                  <p>
                    Per Head- Adult<span>{pkg.price}</span>
                  </p>
                </div>
              </div>

              <div className="col-md-8">
                <div className="itinerary row">
                  <h4>These Packages Include</h4>

                  {includes.map((item, idx) => (
                    <div className="it-bx" key={idx}>
                      <aside className="fig">
                        <Image
                          src={`${process.env.PUBLIC_URL}/images/${item.icon}`}
                          fluid
                        />
                      </aside>
                      <aside className="lab">{item.label}</aside>
                    </div>
                  ))}

                  <div className="less-tag">
                    <p>
                      Note: -{" "}
                      <span>
                        Confirmation needed at least 15 days prior to avail
                        group Package
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default GroupPackageTabs;
